var map = {
	"./af/RestaurantAdmins.json": "./src/locales/af/RestaurantAdmins.json",
	"./af/common.json": "./src/locales/af/common.json",
	"./af/login.json": "./src/locales/af/login.json",
	"./af/menu.json": "./src/locales/af/menu.json",
	"./af/register.json": "./src/locales/af/register.json",
	"./af/welcome.json": "./src/locales/af/welcome.json",
	"./en/App.json": "./src/locales/en/App.json",
	"./en/common.json": "./src/locales/en/common.json",
	"./en/login.json": "./src/locales/en/login.json",
	"./en/menu.json": "./src/locales/en/menu.json",
	"./en/register.json": "./src/locales/en/register.json",
	"./en/welcome.json": "./src/locales/en/welcome.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/locales sync recursive [A-Za-z0-9-_,\\s]+\\.json$/";